import { Box, Collapse, IconButton, Stack, Typography } from "@mui/material";
import { DamsColors } from "../styles/DamsColors";
import { ExpandLess, ExpandMore, WidthFull } from "@mui/icons-material";
import React from "react";

interface ExpandableContainerProps {
    children: React.ReactNode;
    label?: string;
    isTable?: boolean;
    initOpenState?: boolean;
}



function ExpandableContainer({
    children,
    label = '',
    isTable = false,
    initOpenState = false
}: Readonly<ExpandableContainerProps>) {
    const [expanded, setExpanded] = React.useState(initOpenState);


    return (
        <Box width={'100%'}>
            <IconButton onClick={() => setExpanded(!expanded)}
                sx={{ px: 0, justifyContent: 'space-between', width: '100%', alignItems: 'center', borderRadius: 0, bgcolor: DamsColors.Authentication.AuthContainer }} >
                <Typography
                    fontFamily={"Inter"}
                    color={DamsColors.Authentication.Button}
                    fontSize={14}
                    fontWeight={600}
                    pl={0.2}
                >
                    {expanded ? `Click to collapse ${label}` : `Click to expand ${label}`}
                </Typography>
                {expanded ? (
                    <ExpandLess sx={{ color: DamsColors.Text.Highlight }} />
                ) : (
                    <ExpandMore sx={{ color: DamsColors.Text.Highlight }} />
                )}
            </IconButton>

            <Stack alignItems={'center'} justifyContent={'center'}>
                <Collapse in={expanded} timeout="auto" unmountOnExit sx={{ width: '100%' }}>
                    <Box display={ isTable ? '' : 'flex'} alignItems={'center'} justifyContent={'center'} width={'100%'} > 
                        {children}
                    </Box>
                </Collapse>
            </Stack>
        </Box>
    );
}




export { ExpandableContainer };
